import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import {
    BsMoonFill,
    BsSun,
    BsChevronUp,
    BsChevronDown,
    BsArrowCounterclockwise,
    BsVolumeUpFill,
} from "react-icons/bs";
import { FaTextHeight, FaImage, FaMousePointer } from "react-icons/fa";
import { RiTextSpacing } from "react-icons/ri";
import "./accessibility.css";

export default function AccessibilityTools() {
    const [show, setShow] = useState(false);

    const [lineHeight, setLineHeight] = useState("normal");
    const [spacing, setSpacing] = useState(0);

    const [darkMode, setDarkMode] = useState(false);
    const [hideImages, setHideImages] = useState(false);
    const [bigCursor, setBigCursor] = useState(false);

    const toggleShow = () => setShow(!show);

    const [zoom, setZoom] = useState(1);

    // Stores how many times user zoomed in/out
    const [zoomLimit, setZoomLimit] = useState({ up: 0, down: 0 });


    // 🔼 INCREASE TEXT
    const increaseText = () => {
        if (zoomLimit.up >= 2) {
            alert("Maximum limit reached");
            return;
        }

        // Increase zoom
        setZoom(prev => {
            const newZoom = prev + 0.1;
            return newZoom;
        });

        // Reset down counter, increase up counter
        setZoomLimit(prev => ({
            up: prev.up + 1,
            down: 0
        }));
    };


    // 🔽 DECREASE TEXT
    const decreaseText = () => {
        if (zoomLimit.down >= 2) {
            alert("Minimum limit reached");
            return;
        }

        // Sonar-safe boundary check
        setZoom(prev => {
            const newZoom = prev - 0.1;
            return newZoom < 0.8 ? 0.8 : newZoom;  // no Math.max()
        });

        // Reset up counter, increase down counter
        setZoomLimit(prev => ({
            up: 0,
            down: prev.down + 1
        }));
    };


    // 🔄 RESET TEXT
    const resetText = () => {
        setZoom(1);
        setZoomLimit({ up: 0, down: 0 });
    };

    const toggleLineHeight = () =>
        setLineHeight(prev => (prev === "normal" ? "1.2" : "normal"));

    const toggleSpacing = () =>
        setSpacing(prev => (prev === 0 ? 1 : 0));

    // const speakText = () => {
    //     const t = window.getSelection().toString() || document.body.innerText;
    //     speechSynthesis.speak(new SpeechSynthesisUtterance(t));
    // };

    const cardRef = useRef(null);
    const btnRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (
                show &&
                cardRef.current &&
                !cardRef.current.contains(e.target) &&
                btnRef.current &&
                !btnRef.current.contains(e.target)
            ) {
                setShow(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [show]);
    return (
        <>
            {/* Floating Button */}
            <button className="accessibility-btn" onClick={toggleShow} title='Accessibility' ref={btnRef}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="#fff" width='30'>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5625 8.75C11.5625 7.83832 11.9247 6.96398 12.5693 6.31932C13.214 5.67466 14.0883 5.3125 15 5.3125C15.9117 5.3125 16.786 5.67466 17.4307 6.31932C18.0753 6.96398 18.4375 7.83832 18.4375 8.75C18.4375 9.66168 18.0753 10.536 17.4307 11.1807C16.786 11.8253 15.9117 12.1875 15 12.1875C14.0883 12.1875 13.214 11.8253 12.5693 11.1807C11.9247 10.536 11.5625 9.66168 11.5625 8.75ZM15 7.1875C14.5856 7.1875 14.1882 7.35212 13.8951 7.64515C13.6021 7.93817 13.4375 8.3356 13.4375 8.75C13.4375 9.1644 13.6021 9.56183 13.8951 9.85485C14.1882 10.1479 14.5856 10.3125 15 10.3125C15.4144 10.3125 15.8118 10.1479 16.1049 9.85485C16.3979 9.56183 16.5625 9.1644 16.5625 8.75C16.5625 8.3356 16.3979 7.93817 16.1049 7.64515C15.8118 7.35212 15.4144 7.1875 15 7.1875Z" fill="currentColor" stroke="none"></path>
                    <path d="M6.63735 12.1332C6.73434 11.9043 6.91828 11.7233 7.14871 11.63C7.37913 11.5368 7.63718 11.5388 7.8661 11.6357L7.86735 11.637L7.87485 11.6407L7.9086 11.6545L8.0461 11.7107C8.17026 11.7616 8.34526 11.8299 8.5711 11.9157C9.0211 12.087 9.65235 12.3157 10.3773 12.5432C11.8498 13.0057 13.6111 13.437 14.9998 13.437C16.3886 13.437 18.1498 13.0057 19.6223 12.5432C20.4561 12.2791 21.2792 11.9826 22.0898 11.6545L22.1248 11.6407L22.1323 11.637H22.1336C22.3607 11.5488 22.6131 11.5525 22.8375 11.6473C23.0619 11.742 23.2406 11.9203 23.3358 12.1445C23.431 12.3687 23.4352 12.6211 23.3475 12.8484C23.2598 13.0756 23.0872 13.2598 22.8661 13.362L22.8611 13.3645L22.8486 13.3695L22.8086 13.387L22.6548 13.4495C21.8428 13.7744 21.0189 14.0688 20.1848 14.332C18.9498 14.7195 17.3898 15.1307 15.9373 15.2657V16.8157C15.9373 17.3532 16.0923 17.882 16.3836 18.3357L19.5386 23.242C19.6052 23.3456 19.6508 23.4613 19.6728 23.5825C19.6947 23.7037 19.6926 23.828 19.6664 23.9484C19.6403 24.0687 19.5907 24.1828 19.5206 24.284C19.4504 24.3852 19.3609 24.4716 19.2573 24.5382C19.1538 24.6049 19.0381 24.6505 18.9169 24.6724C18.7957 24.6943 18.6713 24.6922 18.551 24.6661C18.4306 24.64 18.3166 24.5904 18.2153 24.5202C18.1141 24.45 18.0277 24.3606 17.9611 24.257L14.9998 19.6495L12.0373 24.257C11.973 24.3654 11.8875 24.4597 11.7859 24.5342C11.6844 24.6088 11.5688 24.6621 11.4461 24.691C11.3234 24.7199 11.1962 24.7238 11.072 24.7024C10.9478 24.681 10.8292 24.6348 10.7233 24.5666C10.6174 24.4983 10.5263 24.4094 10.4555 24.3051C10.3847 24.2008 10.3357 24.0834 10.3113 23.9597C10.287 23.8361 10.2878 23.7088 10.3137 23.5855C10.3397 23.4621 10.3902 23.3453 10.4623 23.242L13.6161 18.3357C13.9076 17.8819 14.0625 17.3539 14.0623 16.8145V15.2657C12.6098 15.1307 11.0498 14.7207 9.8136 14.332C8.92723 14.0519 8.05237 13.7367 7.1911 13.387L7.14985 13.3695L7.1386 13.3645L7.1336 13.3632C7.02022 13.3151 6.91744 13.2451 6.83113 13.1572C6.74482 13.0693 6.67668 12.9653 6.63059 12.8511C6.58451 12.7368 6.56138 12.6146 6.56254 12.4915C6.5637 12.3683 6.58912 12.2466 6.63735 12.1332Z" fill="currentColor" stroke="none"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5625 15C1.5625 7.57875 7.57875 1.5625 15 1.5625C22.4212 1.5625 28.4375 7.57875 28.4375 15C28.4375 22.4212 22.4212 28.4375 15 28.4375C7.57875 28.4375 1.5625 22.4212 1.5625 15ZM15 3.4375C11.9334 3.4375 8.99247 4.65569 6.82408 6.82408C4.65569 8.99247 3.4375 11.9334 3.4375 15C3.4375 18.0666 4.65569 21.0075 6.82408 23.1759C8.99247 25.3443 11.9334 26.5625 15 26.5625C18.0666 26.5625 21.0075 25.3443 23.1759 23.1759C25.3443 21.0075 26.5625 18.0666 26.5625 15C26.5625 11.9334 25.3443 8.99247 23.1759 6.82408C21.0075 4.65569 18.0666 3.4375 15 3.4375Z" fill="currentColor" stroke="none"></path>
                </svg>
            </button>

            {/* Floating Accessibility Card */}
            {show && (
                <div className="accessibility-card" ref={cardRef}>
                    <div className="card-header">
                        <span>Accessibility Tools</span>
                        <button className="close-btn" onClick={toggleShow}>✕</button>
                    </div>

                    <div className="card-body">

                        {/* Color Adjustment */}
                        <h6 className="section-title">Color Adjustment</h6>
                        <Row className="mb-3">
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button
                                    className={`acc-btn ${darkMode ? "active" : ""}`}
                                    onClick={() => setDarkMode(true)}
                                >
                                    <BsMoonFill size={20} />
                                    <p className="mb-0"> Dark</p>
                                </button>
                            </Col>

                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button
                                    className={`acc-btn ${!darkMode ? "active" : ""}`}
                                    onClick={() => setDarkMode(false)}
                                >
                                    <BsSun size={22} />
                                    <p className="mb-0">Normal</p>
                                </button>
                            </Col>
                        </Row>

                        {/* Text Size */}
                        <h6 className="section-title">Text Size</h6>
                        <Row className="mb-3">
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={increaseText}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path><path d="M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path></svg>
                                    <p className="mb-0">Increase Text</p>
                                </button>
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={decreaseText}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M18 6.41L16.59 5 12 9.58 7.41 5 6 6.41l6 6z"></path><path d="M18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path></svg>
                                    <p className="mb-0">Decrease Text</p>
                                </button>
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={resetText}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-width="2" d="M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9"></path></svg>
                                    <p className="mb-0">Reset Text</p>
                                </button>
                            </Col>
                        </Row>

                        {/* Line Height + Letter Spacing */}
                        <Row className="mb-3">
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={toggleLineHeight}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H21V6H11V4ZM6 7V11H4V7H1L5 3L9 7H6ZM6 17H9L5 21L1 17H4V13H6V17ZM11 18H21V20H11V18ZM9 11H21V13H9V11Z"></path></svg>
                                    <p className="mb-0">Line Height</p>
                                </button>
                            </Col>

                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={toggleSpacing}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z"></path></svg>
                                    <p className="mb-0">Text Spacing</p>
                                </button>
                            </Col>
                        </Row>

                        {/* Others */}
                        <h6 className="section-title">Other Options</h6>
                        <Row>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={() => setHideImages(!hideImages)}>
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Image_Off"><path d="M19.937,14.218l0,-8.654c0,-0.829 -0.672,-1.5 -1.5,-1.5l-10.628,-0c-0.276,-0 -0.5,-0.225 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5l10.628,-0c1.38,-0 2.5,1.118 2.5,2.5l0,10.624c0,0.276 -0.224,0.5 -0.5,0.501c-0.276,-0 -0.5,-0.225 -0.5,-0.5l0,-0.556l-4.583,-4.584c-0.456,-0.456 0.251,-1.163 0.707,-0.707c0.162,0.162 2.37,2.37 3.876,3.876Zm-0.121,6.304c-0.395,0.262 -0.869,0.415 -1.379,0.415l-12.874,-0c-1.381,-0 -2.5,-1.119 -2.5,-2.5l0,-12.873c0,-0.51 0.153,-0.984 0.414,-1.38l-0.263,-0.263c-0.456,-0.456 0.251,-1.163 0.707,-0.707c0.088,0.088 0.176,0.176 0.263,0.263c0.245,0.245 16.095,16.094 16.339,16.338l0.263,0.263c0.455,0.456 -0.252,1.163 -0.707,0.707c-0.088,-0.087 -0.175,-0.175 -0.263,-0.263Zm-11.104,-11.103l-2.001,-2.001c-0.094,0.196 -0.146,0.415 -0.146,0.647c-0,0.829 0.672,1.5 1.5,1.5c0.232,-0 0.451,-0.052 0.647,-0.146Zm-2.733,-2.733l-1.77,-1.77c-0.093,0.196 -0.146,0.416 -0.146,0.648l0,10.717l1.926,-1.926c0.587,-0.586 1.536,-0.586 2.122,-0l0.555,0.554c0.195,0.196 0.511,0.196 0.706,0l2.415,-2.415l-2.343,-2.343c-0.395,0.262 -0.869,0.414 -1.379,0.414c-1.38,-0 -2.5,-1.119 -2.5,-2.5c-0,-0.509 0.152,-0.983 0.414,-1.379Zm-1.916,11.009l0,0.741c0,0.829 0.671,1.5 1.5,1.5l12.874,0c0.232,0 0.451,-0.052 0.647,-0.145c-0.165,-0.165 -3.264,-3.263 -6.59,-6.59l-2.414,2.415c-0.585,0.586 -1.537,0.586 -2.122,0l-0.554,-0.554c-0.195,-0.196 -0.512,-0.196 -0.708,0l-2.633,2.633Z"></path></g></svg>
                                    <p className="mb-0">Hide Images</p>
                                </button>
                            </Col>

                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <button className="acc-btn" onClick={() => setBigCursor(!bigCursor)}>
                                    <svg stroke="currentColor" fill="#000" stroke-width="0" viewBox="0 0 20 20" aria-hidden="true" class="h-[20px] w-[20px] sm:h-[24px] sm:w-[24px]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z" clip-rule="evenodd"></path></svg>
                                    <p className="mb-0">Cursor</p>
                                </button>
                            </Col>

                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <a href="/Helpsection" style={{ textDecoration: 'none' }}>
                                    <button className="acc-btn">
                                        <BsVolumeUpFill size={22} />
                                        <p className="mb-0">Read</p>
                                    </button>
                                </a>
                            </Col>
                        </Row>
                    </div>
                </div>
            )}

            {/* Apply zoom + spacing + line height */}
            <style>{`
  #accessibility-wrapper {
    zoom: ${zoom};
  }

  #accessibility-wrapper * {
    line-height: ${lineHeight} !important;
    letter-spacing: ${spacing}px !important;
  }
  ${hideImages ? "#accessibility-wrapper img{visibility:hidden}" : ""}
 ${bigCursor ? `#accessibility-wrapper{cursor:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 20 20' fill='%23FFA500'><path fill-rule='evenodd' d='M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z'/></svg>") 0 0, auto}` : ""}
${darkMode ? "html{filter:invert(1) hue-rotate(180deg)}" : ""}
`}</style >
        </>
    );
}
